import { useState, useEffect, useRef } from "react";
export default function ThreeXPackageIncrease() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(255, 252, 247)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running",
    overflow: "hidden"
  }}>
      <div className="page-container">
        <div ref={ref} className={`flex flex-col md:flex-row items-center md:items-center transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        gap: "120px"
      }}>
          <div className="flex flex-col items-start flex-shrink-0" style={{
          width: "280px",
          minWidth: "200px"
        }}>
            <span style={{
            color: "#C8985C",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "96px",
            fontWeight: "700",
            lineHeight: "1",
            letterSpacing: "0.02em"
          }}>
              3x
            </span>
            <span style={{
            color: "#1F3A2E",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "11px",
            fontWeight: "600",
            letterSpacing: "0.15em",
            marginTop: "12px",
            textTransform: "uppercase"
          }}>
              AVERAGE PACKAGE INCREASE
            </span>
          </div>

          <div className="flex flex-col" style={{
          maxWidth: "660px",
          width: "100%"
        }}>
            <h3 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "30px",
            fontWeight: "400",
            lineHeight: "48.75px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "24px"
          }}>
              Spas using PrepayQR sell 3x more packages — because clients buy
              impulsively at the table.
            </h3>

            <div className="flex flex-col" style={{
            gap: "20px"
          }}>
              <div className="flex flex-row items-start" style={{
              gap: "10px"
            }}>
                <span className="flex-shrink-0" style={{
                color: "#C8985C",
                marginTop: "2px"
              }}>
                  <span dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>`
                }} />
                </span>
                <p style={{
                color: "rgba(42, 45, 43, 0.8)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "22.75px",
                border: "0px solid oklch(0.69 0.04 165 / 0.25)",
                animation: "none 0s ease 0s 1 normal none running",
                margin: "0"
              }}>
                  <strong>Endorphins + trust = low buying resistance.</strong>{" "}
                  No awkward sales conversations needed when they are dressed and
                  standing at the front desk.
                </p>
              </div>

              <div className="flex flex-row items-start" style={{
              gap: "10px"
            }}>
                <span className="flex-shrink-0" style={{
                color: "#C8985C",
                marginTop: "2px"
              }}>
                  <span dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>`
                }} />
                </span>
                <p style={{
                color: "rgba(42, 45, 43, 0.8)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "22.75px",
                border: "0px solid oklch(0.69 0.04 165 / 0.25)",
                animation: "none 0s ease 0s 1 normal none running",
                margin: "0"
              }}>
                  <strong>No awkward sales pitch.</strong> Your therapists hate
                  selling packages. PrepayQR removes the burden from therapists
                  completely.
                </p>
              </div>

              <div className="flex flex-row items-start" style={{
              gap: "10px"
            }}>
                <span className="flex-shrink-0" style={{
                color: "#C8985C",
                marginTop: "2px"
              }}>
                  <span dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>`
                }} />
                </span>
                <p style={{
                color: "rgba(42, 45, 43, 0.8)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "22.75px",
                border: "0px solid oklch(0.69 0.04 165 / 0.25)",
                animation: "none 0s ease 0s 1 normal none running",
                margin: "0"
              }}>
                  <strong>The QR is neutral.</strong> The table does the selling.
                  No pressure, just luxury, convenient value presented when they
                  want it most.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}